import { Box, Drawer } from '@mui/material'
import { FC, useContext } from 'react'

import { FULL_DRAWER_WIDTH, ICONS_ONLY_DRAWER_WIDTH } from '../../config'
import { TABLET_WIDTH_BREAKPOINT } from '../../config/breakPoints'
import { NavVisibilityContext, WindowSizeContext } from '../../providers'
import { DrawerContents } from './DrawerContents'

export const AppNav: FC = () => {
  const { width } = useContext(WindowSizeContext)
  const { stayOpen, setStayOpen, iconsOnly } = useContext(NavVisibilityContext)

  // Icons-only mode only applies to the drawer rendered at sizes at or above
  // the tablet width breakpoint. At sizes below the tablet width breakpoint,
  // the drawer changes to the temporary variant, which means that when the
  // drawer is visible, the drawer is overlaid on top of the rest of the page
  // in a fashion similar to that of a modal. Due to this modal nature of the
  // drawer at smaller window widths, it makes sense for the drawer to not have
  // an icons-only mode.
  const overTabletBreakpoint = width >= TABLET_WIDTH_BREAKPOINT
  const drawerWidth =
    iconsOnly && overTabletBreakpoint
      ? ICONS_ONLY_DRAWER_WIDTH
      : FULL_DRAWER_WIDTH

  return (
    <Box
      data-testid="AppNav"
      component="nav"
      sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}>
      {width >= TABLET_WIDTH_BREAKPOINT ? (
        <Drawer
          data-testid="PermanentDrawer"
          variant="permanent"
          sx={{
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              transition: 'width 0.1s',
              overflowX: 'hidden'
            }
          }}
          open>
          <DrawerContents />
        </Drawer>
      ) : (
        <Drawer
          data-testid="TemporaryDrawer"
          variant="temporary"
          open={stayOpen}
          onClose={() => setStayOpen(false)}
          ModalProps={{
            keepMounted: true
          }}
          sx={{
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              backgroundColor: 'primary.main',
              color: 'primary.contrastText'
            }
          }}>
          <DrawerContents />
        </Drawer>
      )}
    </Box>
  )
}
